import React, { useState, useEffect } from 'react';

// Import all the sections that make up your homepage
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import TechnologiesSection from '../components/TechnologiesSection';
import CoreValuesSection from '../components/CoreValuesSection';
import PortfolioSection from '../components/PortfolioSection';
import ClientsSection from '../components/ClientsSection';
import FAQSection from '../components/FAQSection';
import BlogHighlightSection from '../components/BlogHighlightSection'; // <-- 1. Import the new component
import ContactSection from '../components/ContactSection';

const API_BASE_URL = 'https://smartsolutionslk.com/api/api.php'; // Your live API URL

const HomePage = () => {
  const backendUrl = 'https://test.smartsolutionslk.com/contact_handler.php';

  // Create state to hold the data fetched from the API
  const [projects, setProjects] = useState([]);
  const [testimonials, setTestimonials] = useState([]);

  // This effect runs when the page loads to fetch data from the database
  useEffect(() => {
    const fetchData = async () => {
      try {
        const projectsResponse = await fetch(`${API_BASE_URL}?resource=projects`);
        const projectsData = await projectsResponse.json();
        setProjects(projectsData);

        const testimonialsResponse = await fetch(`${API_BASE_URL}?resource=testimonials`);
        const testimonialsData = await testimonialsResponse.json();
        setTestimonials(testimonialsData);
      } catch (error) {
        console.error("Error fetching homepage data:", error);
      }
    };

    fetchData();
  }, []); // The empty array ensures this runs once when the component mounts

  return (
    <>
      <HeroSection />
      <AboutSection />
      {/* Pass the live data as props to the components */}
      <ServicesSection allProjects={projects} />
      <TechnologiesSection />
      <CoreValuesSection />
      <PortfolioSection allProjects={projects} />
      <FAQSection />
           {/* <BlogHighlightSection />  <-- 2. Add the new component here */}
      <ClientsSection testimonials={testimonials} />
      <ContactSection backendUrl={backendUrl} />
    </>
  );
};

export default HomePage;